import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux'
import store from './redux/store';
import { HrApp } from './utils/context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <BrowserRouter>
  <React.StrictMode>
    <HrApp>
    <Provider store={store}>
  
    <App />

    </Provider>
    </HrApp>
  </React.StrictMode>
  </BrowserRouter>
);


